import { combineReducers } from "redux";

import getLaborContract from "./getLaborContract";
import getProfileWork from "./getProfileWork";
import getProfileWorkBefore from "./getProfileWorkBefore";
import formEditProfileWorkBefore from "./formEditProfileWorkBefore";
import updateProfileWorkBefore from "./updateProfileWorkBefore";
import getFileLaborContract from "./getFileLaborContract";

const operationProcessReducer = combineReducers({
  getLaborContract,
  getProfileWork,
  getProfileWorkBefore,
  formEditProfileWorkBefore,
  updateProfileWorkBefore,
  getFileLaborContract,
});

export default operationProcessReducer;
